import { useEffect } from 'react'

const DEFAULT_TITLE = 'Private Agreement'

// Sets document.title and the meta description for the current page and
// restores the defaults on unmount (roadmap 26.2). Client-side only — link
// previews for messengers come from the backend /og/announcement/:id page.
export const usePageMeta = (title?: string, description?: string) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Private Agreement`
    }

    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null
    const previousDescription = meta?.content
    if (description) {
      if (!meta) {
        meta = document.createElement('meta')
        meta.name = 'description'
        document.head.appendChild(meta)
      }
      meta.content = description
    }

    return () => {
      document.title = DEFAULT_TITLE
      if (meta && previousDescription !== undefined) {
        meta.content = previousDescription
      }
    }
  }, [title, description])
}
